const SET_DARKMODE = (state, value) => {
    state.darkmode = value
    saveState('theme.darkmode', value)
}

const TOGGLE_DARKMODE = (state) => {
    let value = !state.darkmode
    state.darkmode = value
    saveState('theme.darkmode', value)
}

export default {
    SET_DARKMODE,
    TOGGLE_DARKMODE
}

function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}
